'use client';
import type React from 'react';
import './globals.css';
import '@/lib/css/reset.css';
import styles from './layout.module.scss';
import {UnexpectedClientError} from '@/components/error/unexpected-client-error';

export default function ErrorPage() {
  return (
    <html lang="en">
      <body className={styles.layout}>
        <UnexpectedClientError />
      </body>
    </html>
  );
}
